import React from 'react';
import { useTranslation } from 'react-i18next';
import CountriesTable from '../../components/Countries/CountriesTable';
import SuccessAlert from '../../components/widgets/SuccessAlert';

const Countries = props => {

  const { t } = useTranslation();

  return ( 
    <>

      <div className="content p-4">

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">{t('dashboard:hdgHeading')}</a></li>            
            <li className="breadcrumb-item active" aria-current="page">{t('countriesPage:hdgHeading')}</li>
          </ol>
        </nav>

        <SuccessAlert message={props.location?.state?.message} />

        <CountriesTable />

      </div>
    </>
  );
}


export default Countries;